import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActionRole } from '@modules/auth/models/user-auth.model';

@Component({
    selector: 'eig-filter-form-actions',
    templateUrl: './filter-form-actions.component.html'
})
export class FilterFormActionsComponent {

    @Input()
    actionRole: ActionRole;

    @Input()
    hasSelectedValues: boolean;

    @Input()
    sectionName: string;

    @Output()
    readonly openCreateDialog = new EventEmitter<boolean>();

    @Output()
    readonly deleteSelected = new EventEmitter<boolean>();

    @Output()
    readonly resetForm = new EventEmitter<boolean>();

    @Output()
    readonly startSearch = new EventEmitter<boolean>();

    @Output()
    readonly exportSelected = new EventEmitter<boolean>();

    @Output()
    readonly exportAll = new EventEmitter<boolean>();

    onOpenCreateDialog(): void {
        this.openCreateDialog.next(true);
    }

    onDeleteSelected(): void {
        this.deleteSelected.next(true);
    }

    onResetForm(): void {
        this.resetForm.next(true);
    }

    onStartSearch(): void {
        this.startSearch.next(true);
    }

    onExportAll(): void {
        this.exportAll.next(true);
    }

    onExportSelected(): void {
        this.exportSelected.next(true);
    }
}
